import React, {Component} from 'react'
import {Input} from 'reactstrap'
import PropTypes from 'prop-types'
import moment from 'moment'
import {Mutation} from 'react-apollo'
import {AvForm, AvInput} from 'availity-reactstrap-validation'
import {toast} from 'react-toastify'

import LoadingButton from '../LoadingButton'
import addProjectFeeRateMutation from '../../../queries/server/mutations/add_project_fee_rate'
import editProjectLocalMutation from '../../../queries/client_side/mutations/edit_project'

export default class ProjectFeeRateInput extends Component {

    constructor(props) {
        super(props)
        this.form = null
        this.state = {
            active_from_date: moment(props.active_from_date).format('YYYY-MM-DD') || moment().format('YYYY-MM-DD'),
            hourly_rate: props.hourly_rate || 71,
        }
    }

    render() {

        const {active_from_date, hourly_rate} = this.state
        const {project_id, onSaved, onCancel, successMessage} = this.props

        return (
            <Mutation mutation={addProjectFeeRateMutation}>
                {(addProjectFeeRateMutationFunc, {loading}) => (
                    <Mutation mutation={editProjectLocalMutation}>
                        {(editProjectLocalMutationFunc) => (
                            <AvForm
                                ref={ref => this.form = ref}
                                className="d-flex flex-row" style={{flex: '1'}}
                                onValidSubmit={() => {
                                    addProjectFeeRateMutationFunc({
                                        variables: {
                                            project_id,
                                            data: [{active_from_date, hourly_rate}]
                                        }
                                    })
                                        .then(({data}) => {
                                            toast.success(successMessage, {autoClose: 2000})
                                            if(onSaved) onSaved()
                                            editProjectLocalMutationFunc({
                                                variables: {
                                                    data: data.upsertProjectFeeRates
                                                }
                                            })
                                        })
                                        .catch(e => toast.error(e.message, {autoClose: false}))
                                }}
                            >
                                <div className="d-flex mr-2" style={{flex: '1'}}>
                                    <AvInput
                                        required
                                        name="active_from_date"
                                        type="date"
                                        className="form-control-sm"
                                        placeholder="Active From Date"
                                        value={active_from_date}
                                        onChange={(evt) => this.setState({active_from_date: evt.target.value})}
                                    />
                                </div>
                                <div className="d-flex mr-2" style={{flex: '1'}}>
                                    <AvInput
                                        required
                                        name="hourly_rate"
                                        type="number"
                                        className="form-control-sm"
                                        placeholder="Hourly Rate"
                                        value={hourly_rate}
                                        onChange={(evt) => this.setState({hourly_rate: evt.target.value})}
                                    />
                                </div>
                                <div className="d-flex mr-1">
                                    <LoadingButton
                                        size="sm"
                                        color="secondary"
                                        className="square-btn"
                                        icon="times"
                                        loading={false}
                                        onClick={() => {
                                            if (onCancel) onCancel()
                                        }}
                                    />
                                </div>
                                <LoadingButton
                                    size="sm"
                                    color="success"
                                    className="square-btn"
                                    icon="save"
                                    loading={loading}
                                />
                            </AvForm>
                        )}

                    </Mutation>
                )}
            </Mutation>
        )

    }

}

ProjectFeeRateInput.propTypes = {
    project_id: PropTypes.string.isRequired,
    active_from_date: PropTypes.string,
    hourly_rate: PropTypes.number,
    onSaved: PropTypes.func,
    onCancel: PropTypes.func,
    successMessage: PropTypes.string
}